// extracted by mini-css-extract-plugin
export default {"Title":"BoxHeader_Title__5Ewdp"};